<template>
  <div @click="goDetail" class="course-card">
    <span
      class="tag-btn"
      :style="{ background: resultMap[courseData.results_id] }"
      v-if="showResultTag && courseData.results_id"
    >
      {{ courseData.results_name }}
    </span>
    <div class="course">
      <div class="top">
        <div class="course-card-cover">
          <img :src="courseData.course_cover_url || require('@/assets/images/common/course_cover.png')" />
        </div>
        <div v-if="courseData.classify_name">
          <div class="course-name text-overflow" :title="courseData.course_name.length> 15 ? courseData.course_name : ''" id="courseName">{{ courseData.course_name }}</div>
          <!-- <div class="course-classify-name text-overflow">{{ courseData.classify_name }}</div> -->
        </div>
        <div v-else class="course-name text-overflow" id="courseName">{{ courseData.course_name }}</div>
      </div>
      <div class="bottom">
        <div class="teacher">
          <div class="name texts" :title="courseData.lecturer.length> 10 ? courseData.lecturer : ''">{{ courseData.lecturer || "暂无" }}</div>
          <div class="name ml" :title="courseData.classify_name&&courseData.classify_name.length > 16 ? courseData.classify_name : ''">{{ courseData.classify_name||'暂无' }}</div>
        </div>
        <div class="time">
          <span>{{ courseData.students_num || 0 }}人参加</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { handleLogin } from '@/plugins/utils'
export default {
  props: {
    courseData: {
      required: true,
      type: Object
    },
    showLabel: {
      required: false,
      type: Boolean,
      default: false
    },
    labelContent: {
      required: false,
      type: String,
      default: 'course_type_name'
    },
    cols: {
      required: false,
      type: String,
      default: 'n + 3'
    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number,
    resultMap: Object,
    showResultTag: Boolean
  },
  methods: {
    goDetail() {
      if (this.authType == 2 && !this.userInfo) {
        handleLogin()
      } else {
        this.courseData.course_url && window.open(this.courseData.course_url)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.course-card {
  width: 100%;
  height: 236px !important;
  margin-bottom: 0px !important;
  margin-bottom: 30px;
  background-color: #F7F8FA;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  transition: all 0.5s;

  &:hover {
    transform: translate(0, -5px);
    box-shadow: 0 2px 12px rgba(160, 160, 160, 0.23);
    transition: all 0.5s;
    background-color: #fff !important;
  }

  .tag-btn {
    position: absolute;
    top: 13px;
    left: 13px;
    font-size: 12px;
    padding: 5px 10px;
    background-color: var(--el-color-primary);
    color: #fff;
    min-width: 60px;
    text-align: center;

    /* 梯形形状 */
    clip-path: polygon(5% 100%, 100% 100%, 91% 0%, 0% 0%);
  }

  .course {
    width: 100%;
    height: 100%;

    .course-card-cover {
      height: 147px !important;
      margin-bottom: 12px;
      overflow: hidden;

      img {
        transition: all 0.5s;
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }

    .course-name {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #1D2129;
      padding: 0px 8px;
    }

    .course-classify-name {
      font-size: 14px;
      color: #aaa;
      padding-right: 10px;
      text-align: right;
      margin-bottom: 10px;
    }

    .bottom {
      margin-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 8px;

      .teacher {
        display: flex;
        align-items: center;

        .avatar {
          width: 19px;
          height: 19px;
          border: 1px solid $--border-color;
          border-radius: 50%;
          margin-right: 5px;
        }

        .name {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #1D2129;
        }
        .texts{
          width: auto;
          max-width: 56px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #86909C;
      }

      .course-data {
        display: flex;
        justify-content: space-between;

        .data-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          font-weight: 400;

          .num {
            font-size: 18px;
            color: #153e77;
            line-height: 20px;
            font-weight: 700;
          }
        }
      }
    }
  }
}

.course-card:nth-of-type() {
  margin-left: 21px;
}

.course-card .text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.course-mescredit {
  margin-left: 12px;

  .num {
    color: $--color-primary;
  }
}

.course-mes .course-meshour {
  // margin-right: 15px;
  margin-left: 10px;

  .num {
    color: $--color-primary;
  }
}

.ml {
  margin-left: 8px;
  width: auto;
  max-width: 190px;
  width: auto;
  max-width: 190px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
